<script setup lang="ts">
import type { Tone, ToneGlyph } from '@/lib/tone'
import ToneGlyphIcon from './ToneGlyph.vue'

const props = withDefaults(
  defineProps<{
    tone: Tone
    glyph: ToneGlyph
    label: string
    value: number
    muted?: boolean
  }>(),
  { muted: false },
)
</script>

<template>
  <div
    class="card flex flex-col gap-1 p-4"
    :data-tone="props.tone"
  >
    <div class="tone-ink flex items-center gap-2">
      <ToneGlyphIcon :glyph="props.glyph" />
      <span class="eyebrow">{{ props.label }}</span>
    </div>
    <p
      class="tabular text-3xl font-semibold"
      :class="props.muted ? 'text-ink' : 'tone-ink'"
      :aria-label="`${props.value} ${props.label}`"
    >
      {{ props.value }}
    </p>
  </div>
</template>

<style scoped>
/* No :style binding, per the house rule: the tone token supplies the colour,
   this class just applies it. */
.tone-ink {
  color: var(--tone-ink);
}
</style>
